import { environment } from './../../../../environments/environment';
import { LogicService } from './../../../services/logic.service';
import { AuthenticationService } from './../../../services/authentication.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy, AfterContentInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AppState } from '../../../models/appState';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PeriodTypeEnum, Parameter, FundParameters, EmployeeDataLoader } from '@akiba/models_bimbo';

@Component({
  selector: 'app-employee-home',
  templateUrl: './employee-home.component.html',
  styleUrls: ['./employee-home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeHomeComponent implements OnInit, OnDestroy, AfterContentInit {

  contentLocation: AppState = new AppState();
  //////////////////////////////////////
  principalSubscription: Subscription;
  parameterSubscription: Subscription;
  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  retirementSavingParameter: Parameter | null = null;
  permanentLoanParameter: Parameter | null = null;
  retirementLoanParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;
  longFundParameter: FundParameters | null = null;
  //////////////////////////////////////
  permanentSavingDisabledReason = '';
  permanentSavingLoanDisabledReason = '';
  retirementSavingLoanDisabledReason = '';

  hideShortFund = true;

  caja: string;
  fondo: string;
  general: string;
  laboral: string;
  prestamos: string;

  cajaIcon: string;
  fondoIcon: string;
  generalIcon: string;
  laboralIcon: string;
  prestamosIcon: string;
  shareSavingsHide: false;
  shareSavingsParameters: any;
  shareSavingsDisabled: boolean;

  employeeInfo = '';
  constructor(public logicService: LogicService, private authService: AuthenticationService, private dataService: DataSourceService) {

    this.caja = environment.images.states.selected.caja;
    this.fondo = environment.images.states.unselected.fondo;
    this.general = environment.images.states.unselected.general;
    this.laboral = environment.images.states.unselected.laboral;
    this.prestamos = environment.images.states.unselected.prestamos;

    this.cajaIcon = environment.images.states.normal.caja;
    this.fondoIcon = environment.images.states.normal.fondo;
    this.generalIcon = environment.images.states.normal.general;
    this.laboralIcon = environment.images.states.normal.laboral;
    this.prestamosIcon = environment.images.states.normal.prestamos;

    this.logicService.dataManager.proxyDataLoader = this.logicService.dataManager.principalDataLoader.employee ? new EmployeeDataLoader(null) : this.logicService.dataManager.proxyDataLoader;


  }

  procData() {

    if (!this.logicService.dataManager.principalDataLoader.employee || !this.logicService.dataManager.parameterDataLoader.parameters) {
      return;
    }

    if (this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation && this.logicService.dataManager.principalDataLoader.employee.workInformation.laidOff) {
      this.authService.signOut();
      return;
    }
    
    const parameters = this.logicService.dataManager.parameterDataLoader.parameters;
    const fundParameters = this.logicService.dataManager.parameterDataLoader.fundParameters;

    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.logicService.dataManager.principalDataLoader.employee));
    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.logicService.dataManager.principalDataLoader.employee));
    this.permanentLoanParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.loanParameterAppliesTo(this.logicService.dataManager.principalDataLoader.employee));
    this.retirementLoanParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.loanParameterAppliesTo(this.logicService.dataManager.principalDataLoader.employee));
    this.shortFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.shortSavingFund).find(e => e.fundAppliesTo(this.logicService.dataManager.principalDataLoader.employee));
    this.longFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.longSavingFund).find(e => e.fundAppliesTo(this.logicService.dataManager.principalDataLoader.employee));

  }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.principalSubscription = this.logicService.dataManager.principalDataLoader.changes.subscribe(d => {
      const employeeInfoToShow = d && d.response ? 'Colaborador ' + d.response.workInformation.employeeNumber + ' - ' + d.response.displayName : 'Cargando Información ...';
      this.employeeInfo = employeeInfoToShow;
      this.hideShortFund = d && d.response && d.response.funds.find(e => e.type === 'FAC') ? false : true;
      this.procData();
      this.shouldHideShareSavings();
    });

    this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

      if (p && p.response) {
        this.procData();
      }

    });
  }

  ngOnDestroy(): void {

    if (this.principalSubscription && !this.principalSubscription.closed) {
      this.principalSubscription.unsubscribe();
      this.principalSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

  get activeStatusPermanentSavings(): boolean {
    // ahorro en 0 no se muestra    
    if (this.logicService.dataManager.principalDataLoader.employee.permanentSavings) {
      const total: number = (this.logicService.dataManager.principalDataLoader.employee.permanentSavings.total + this.logicService.dataManager.principalDataLoader.employee.permanentSavings.totalExtras) - this.logicService.dataManager.principalDataLoader.employee.permanentSavings.totalWithdrawals;
      /* if (total <= 0) {
         return false
       } else {*/
      return true;
      //   }

    } else {
      return false;

    }
  }
  ////////////////////////////////////////////////

  get shouldDisablePermanentSavingButton(): boolean {

    if (!this.permanentSavingParameter) {
      this.permanentSavingDisabledReason = 'No es posible registrarse ya que esta fuera de periodo.';
      return true;
    }

    if (this.logicService.dataManager.principalDataLoader.employee.permanentSavings && this.logicService.dataManager.principalDataLoader.employee.permanentSavings.status == 'active') {
      return false;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.logicService.dataManager.principalDataLoader.employee)) {
      this.permanentSavingDisabledReason = 'En este momento no es posible registrarse ya que estamos dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (!this.permanentSavingParameter.isRegistrationDateAllowed) {
      this.permanentSavingDisabledReason = 'En este momento no es posible la reinscripción ya que esta fuera del periodo.';
      return true;
    }

    return false;
  }

  get shouldDisablePermanentLoanButton(): boolean {

    this.permanentSavingLoanDisabledReason = '';


    if (this.logicService.dataManager.principalDataLoader.employee.permanentSavingsLoan !== null) {
      return false;
    }

    if (!this.permanentLoanParameter) {
      this.permanentSavingLoanDisabledReason = 'No es posible solicitar un préstamo ya que se esta fuera del periodo.';
      return true;
    }

    if (!this.permanentLoanParameter.applicableLoanParameter) {
      this.permanentSavingLoanDisabledReason = 'No es posible solicitar un préstamo ya que no se ha especificado el siguiente periodo.';
      return true;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.logicService.dataManager.principalDataLoader.employee)) {
      this.permanentSavingLoanDisabledReason = 'En este momento no es posible solicitar un préstamo ya que se esta dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (!this.permanentLoanParameter.isLoanDateAllowed) {
      return true;
    }

    return false;

  }

  ////////////////////////////////////////////////

  get shouldHideRetirementSavings(): boolean {

    return this.logicService.dataManager.principalDataLoader.employee.retirementSavingsData === null || this.logicService.dataManager.principalDataLoader.employee.retirementSavingsData.length === 0;

  }

  get shouldHideRetirementLoan(): boolean {

    if (this.retirementLoanParameter) {

      if (this.logicService.dataManager.principalDataLoader.employee.workInformation.wage.wageName.toUpperCase() === 'CATORCENAL') {

        return this.logicService.dataManager.principalDataLoader.employee.retirementSavingsData === null || this.logicService.dataManager.principalDataLoader.employee.retirementSavingsData.length === 0;

      }

    }

    return true;

  }

  get shouldDisableRetirementLoanButton(): boolean {


    if (this.logicService.dataManager.principalDataLoader.employee.retirementSavingsLoan) {
      return false;
    }

    if (this.logicService.isTodayAPayrollDayForEmployee(this.logicService.dataManager.principalDataLoader.employee)) {
      this.retirementSavingLoanDisabledReason = 'En este momento no es posible solicitar un préstamo ya que se esta dentro de un periodo de pago, inténtelo mas tarde.';
      return true;
    }

    if (!this.retirementLoanParameter) {
      this.retirementSavingLoanDisabledReason = 'No es posible solicitar un préstamo a la caja de ahorro de retiro.';
      return true;
    } else {
      return false;
    }

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  shouldHideShareSavings() {
    if (this.logicService.dataManager.principalDataLoader.employee) {
      const shareSaving = this.logicService.activeShareSavings(this.logicService.dataManager.principalDataLoader.employee).then(async (r) => {

        this.shareSavingsParameters = r;
        this.shareSavingsHide = r.visible;

        const shareSavingsData = await this.dataService.shareSavingsUser(this.logicService.dataManager.principalDataLoader.employee.workInformation.employeeNumber);
        const shareSavingsRegister = shareSavingsData ? shareSavingsData.docs.map(x => x.data()) : [];

        if (!r.habilitado && shareSavingsRegister.length === 0) {
          this.shareSavingsDisabled = true;

        } else {
          this.shareSavingsDisabled = false;

        }

      }).catch(error => console.log(error));

    }



  }


  ////////////////////////////////////////////////

  get shouldDisableShortFund(): boolean {

    if (!this.shortFundParameter) {
      return true;
    }

    return false;

  }

  get shouldDisableLongFund(): boolean {

    if (!this.longFundParameter) {
      return true;
    }

    return false;

  }

  ////////////////////////////////////////////////

  tabChanged(event: MatTabChangeEvent): void {

    this.contentLocation.tabIndex = event.index;
    this.contentLocation.detailIndex = 0;
    this.contentLocation.contentIndex = 0;
    this.contentLocation.savingParametersIndex = 0;

    this.caja = environment.images.states.unselected.caja;
    this.fondo = environment.images.states.unselected.fondo;
    this.general = environment.images.states.unselected.general;
    this.laboral = environment.images.states.unselected.laboral;
    this.prestamos = environment.images.states.unselected.prestamos;

    if (event.index === 0) {
      this.caja = environment.images.states.selected.caja;
    } else if (event.index === 1) {
      this.prestamos = environment.images.states.selected.prestamos;
    } else if (event.index === 2) {
      this.fondo = environment.images.states.selected.fondo;
    }

  }

  subTabChangeSavings(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex === 0) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

  subTabChangeLoans(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex === 1) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

  subTabChangeFunds(event: MatTabChangeEvent): void {

    if (this.contentLocation.tabIndex === 2) {

      this.contentLocation.detailIndex = event.index;
      this.contentLocation.contentIndex = 0;
      this.contentLocation.savingParametersIndex = 0;

    }

  }

}
